import { defer } from 'rxjs';
export var tapSubscribe = function (callback) {
    return function (source) {
        return defer(function () {
            callback();
            return source;
        });
    };
};
//# sourceMappingURL=tapSubscribe.js.map